
import { Vue } from "vue-class-component";

export default class IconCodAmount extends Vue {}
